import {
  TableTranslationsKeys,
  ColumnManagerTranslationFallbackKeys,
} from "@tfg/ui"
import { useTranslation } from "react-i18next"

export const useGetTableTranslations = (): Record<
  keyof typeof TableTranslationsKeys,
  string
> => {
  const { t } = useTranslation("common")

  return {
    total: t("table.total"),
    rowsPerPage: t("table.rowsPerPage"),
    pinColumn: t("table.pinColumn"),
    unpinColumn: t("table.unpinColumn"),
    hideColumn: t("table.hideColumn"),
    showColumn: t("table.showColumn"),
    manageColumns: t("table.manageColumns"),
    noDataMessage: t("table.noDataMessage"),
    noDataTitle: t("table.noDataTitle"),
  }
}

export const useGetColumnManagerTranslations = (): Record<
  keyof typeof ColumnManagerTranslationFallbackKeys,
  string
> => {
  const { t } = useTranslation("common")

  return {
    columns: t("columnManager.columns"),
    visibleColumns: t("columnManager.visibleColumns"),
    hiddenColumns: t("columnManager.hiddenColumns"),
    pinnedColumns: t("columnManager.pinnedColumns"),
    noColumnsMatch: t("columnManager.noColumnsMatch"),
    searchPlaceholder: t("columnManager.searchPlaceholder"),
  }
}
